module.exports = __webpack_public_path__ + "img/threestart.5efd6a5f.png";